/* eslint-disable arrow-parens */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Grid, InputAdornment, Paper, TextField, Tooltip } from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import LockIcon from "@material-ui/icons/Lock";
import InfoIcon from "@material-ui/icons/Info";
import CreateIcon from "@material-ui/icons/Create";

import { Member } from "../../../../../../@types/member.types";
import initCapitalize from "../../../../../../utils/commonFunctions/initCapitalize";
import { handleSSNFormat, handleSSNFormatForView } from "../../../../../../utils/commonFunctions/SSN";
import { AuthContext, GroupContext, UIContext } from "../../../../../../contexts";

import "./memberSettings.css";
import { DynamicFormField } from "../../../../../../@types/dynamicForm.types";
import ExtractRouteParams from "../../../../../../utils/commonFunctions/extractRouteParams";
import { useNavigate } from "react-router-dom";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../constants/caption/dashboardHeader";
import DynamicInformationForm from "../../../../../shared/dynamicInformationForm/DynamicInformationForm";
import { mongoDBDateParserToUSAFormat } from "../../../../../../utils/commonFunctions/date";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { api } from "../../../../../../utils/api";

type MemberSettingsProp = {
	member: Member;
};

const MemberSettings: React.FC<MemberSettingsProp> = ({ member }): JSX.Element => {
	const [memberDetails, setMemberDetails] = useState<DynamicFormField[]>([]);
	const { user } = useContext(AuthContext);
	const { setDashboardHeader } = useContext(UIContext);
	const routeParam = ExtractRouteParams();
	const navigate = useNavigate();
	const { currentGroup, setCurrentGroup } = useContext(GroupContext);
	const queryGroupNumber = useRouteParam("gn");

	const handleRedirectResetPassword = useCallback(() => {
		const pathname = `/employer/member/change-password?${routeParam}`;
		navigate(pathname);
		// alert("Feature is yet to Live!");
	}, [navigate, routeParam]);

	const handleRedirectEditInformation = useCallback(() => {
		const pathname = `/employer/member/edit-member-settings?${routeParam}`;
		navigate(pathname);
	}, [navigate, routeParam]);

	useEffect(() => {
		setMemberDetails(
			Object.assign(
				[],
				[
					{
						label: "Username",
						name: "user_name",
						value: member.user_name ? member.user_name : "N/A",
						onChange: () => null,
						type: "textfield"
					},
					{
						label: "Email",
						name: "email",
						onChange: () => null,
						value: member.email,
						type: "textfield"
					},
					{
						// label: "SSN",
						label: currentGroup?.SSN_provided_by_group ? "SSN" : "ALT-ID",
						name: "SSN",
						onChange: () => null,
						value: handleSSNFormatForView(user, member.SSN),
						type: "textfield"
					},
					{
						label: "Upload Type",
						name: "upload_type",
						onChange: () => null,
						value: initCapitalize(member.upload_type),
						type: "textfield"
					},
					{
						label: "Last Login",
						name: "last_login",
						onChange: () => null,
						value: member.last_login_date
							? mongoDBDateParserToUSAFormat(member.last_login_date as unknown as string)
							: "Not Yet Logged In",
						type: "textfield"
					}
				]
			)
		);
	}, [member, user]);

	useEffect(() => {
		if (queryGroupNumber) {
			const fetchGroup = async () => {
				try {
					const group = await api.group.getGroupByGroupNumber(queryGroupNumber as number);
					setCurrentGroup(group);
				} catch (error) {
					console.error("Error fetching group:", error);
				}
			};

			fetchGroup();
		}
	}, [queryGroupNumber, setCurrentGroup]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.member_settings);
	}, [setDashboardHeader]);

	return (
		<div className="member-settings-container" id="member-settings-container">
			<div className="member-action-button-container" id="pf-action-button-container">
				<Button className="button-green" onClick={handleRedirectResetPassword} variant="contained">
					<span className="button-label-with-icon">Change Password</span>
					<span>
						<LockIcon className="button-icon" />
					</span>
				</Button>
			</div>

			<div className="pf-title">Member Settings</div>

			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button className="button-black" onClick={handleRedirectEditInformation} variant="contained">
					<span className="button-label-with-icon">Edit</span>
					<span>
						<CreateIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<div className="dynamic-form-container" id="dynamic-form-container">
				{memberDetails !== undefined ? (
					<DynamicInformationForm
						informationFormData={memberDetails}
						employee_id={member._id}
						employee_role={member.role}
					/>
				) : null}
			</div>
		</div>
	);
};

export default MemberSettings;
